import { StatusIndicator } from '@routable/gross-ds';
import React from 'react';
import { ExternalBlock, ExternalBlockItem } from 'modules/external/ExternalBlocksSection';
import {} from './ExternalReceiptItemStatus.types';
const ExternalReceiptItemStatus = ({ status, statusText, text }) => (React.createElement(ExternalBlock, null,
    React.createElement(ExternalBlockItem, null,
        React.createElement(StatusIndicator, { className: "text-sm", status: status }, statusText),
        React.createElement("span", { className: "text-grey-60 text-sm" }, text))));
export default ExternalReceiptItemStatus;
